import React, { useState, useEffect } from "react";
import Header from "../../common/Header";
import Footer from "../../common/Footer";
import { Box, Container } from "@mui/material";
import GalleryShowcase from "./GalleryShowcase";
import GalleryBanner from "./GalleryBanner";
import GalleryDetailPage from "./GalleryDetailPage";
import { galleryData } from "./GalleryData";

const GalleryHomePage = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [view, setView] = useState("gallery"); // "gallery" or "detail"

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [view]); // Scroll to top when view changes

  const handleImageSelect = (image) => {
    setSelectedImage(image);
    setView("detail");
  };

  const handleBack = () => {
    setView("gallery");
    setSelectedImage(null);
  };

  return (
    <>
      <Header />
      <Box sx={{ backgroundColor: "#ffff" }}>
        {view === "gallery" ? (
          <>
            <GalleryBanner />
            <Container>
              <GalleryShowcase
                galleryData={galleryData}
                onImageSelect={handleImageSelect}
              />
            </Container>
          </>
        ) : (
          <GalleryDetailPage
            image={selectedImage}
            galleryData={galleryData}
            onBack={handleBack}
          />
        )}
      </Box>
      <Footer />
    </>
  );
};

export default GalleryHomePage;
